/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

// LAVIRENA fix (2026-10-23): several product-page helper scripts rewrite the size
// <legend> text and re-add existing classes on every DOM change, which created an
// endless mutation loop. That loop starved the purchase-gate sync, so a size only
// "stuck" after 2-3 clicks. Skip writes that would not change anything.
(() => {
  if (window.__lvMutationLoopGuard) return;
  window.__lvMutationLoopGuard = true;
  const desc = Object.getOwnPropertyDescriptor(Node.prototype, 'textContent');
  if (desc && desc.set && desc.get) {
    Object.defineProperty(Node.prototype, 'textContent', {
      configurable: true,
      enumerable: desc.enumerable,
      get: desc.get,
      set(value) {
        if (this.nodeType === 1 && this.tagName === 'LEGEND' && desc.get.call(this) === String(value)) return;
        desc.set.call(this, value);
      },
    });
  }
  const add = DOMTokenList.prototype.add;
  DOMTokenList.prototype.add = function (...tokens) {
    const missing = tokens.filter((token) => !this.contains(token));
    if (missing.length) add.apply(this, missing);
  };
})();
